<template>
  <el-dialog
    append-to-body
    width="500px"
    title="分配代理"
    center
    :visible.sync="visible"
    :before-close="reset"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
  >
    <el-form
      v-loading="loading"
      element-loading-text="加载中…"
      ref="elFormDom"
      label-width="110px"
      label-position="right"
      :model="form.data"
      :rules="form.rules"
    >
      <el-form-item prop="name" label="用户名称">
        {{ info.nickname }}
      </el-form-item>
      <el-form-item prop="share_agent_id" label="分配代理">
        <el-select
          v-model="form.data.share_agent_id"
          clearable
          filterable
          @focus="init"
          @change="agentChange"
        >
          <el-option
            v-for="item in agentList_"
            :key="item.id"
            :label="`${item.nickname} - ${item.agent_school_names}`"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="share_id" label="业务员">
        <el-select v-model="form.data.share_id" clearable filterable>
          <el-option
            v-for="item in salesmanList_"
            :key="item.id"
            :label="`${item.nickname} - ${item.school_name}`"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <template #footer>
      <el-row type="flex" justify="center">
        <el-button
          type="primary"
          :loading="form.loading"
          :disabled="form.loading"
          @click="confirm"
          >确定</el-button
        >
        <el-button @click="toggle(false)">取消</el-button>
      </el-row>
    </template>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      info: {},
      agentList_: [],
      salesmanList_: [],
      visible: false,
      loading: false,
      form: {
        loading: false,
        data: {
          share_agent_id: "",
          share_id: "",
        },
        rules: {
          share_agent_id: [
            { required: true, message: "必填项", trigger: "change" },
          ],
          // share_id: [{ required: true, message: "必填项", trigger: "change" }],
        },
      },
    };
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      this.$http
        .get("/admin/agent/list", { params: { page: 1, count: 9999 } })
        .then((res) => {
          if (res.code === 1) {
            this.agentList_ = res.data.list;
          }
        });
    },
    agentChange(val) {
      if (val) {
        this.getSalesman();
      } else {
        this.form.data.share_id = "";
        this.salesmanList_ = [];
      }
    },
    getSalesman() {
      this.$http
        .get("/admin/salesman/list", {
          params: {
            page: 1,
            count: 9999,
            agent_id: this.form.data.share_agent_id,
          },
        })
        .then((res) => {
          if (res.code === 1) {
            this.salesmanList_ = res.data.list;
          }
        });
    },
    reset(done) {
      this.salesmanList_ = [];
      this.agentList_ = [];
      this.info = {};
      this.$refs.elFormDom.resetFields();
      done && done();
    },
    toggle(show) {
      this.visible = show;
      !show && this.reset();
    },
    getDetail(row) {
      this.info = row;
      this.form.data.share_agent_id = row.share_agent_id || '';
      this.agentChange(row.share_agent_id)
      this.form.data.share_id = row.share_id || '';
      this.init();
    },
    // 提交
    confirm() {
      this.$refs.elFormDom.validate((valid) => {
        if (valid) {
          this.form.loading = true;
          let params = {
            id: this.info.id,
            share_agent_id: this.form.data.share_agent_id,
            share_id: this.form.data.share_id,
          };
          this.$http
            .post("/admin/order/setShare", params)
            .then((res) => {
              if (res.code === 1) {
                this.toggle(false);
                this.$emit("refresh");
              }
            })
            .finally(() => {
              this.form.loading = false;
            });
        }
      });
    },
  },
};
</script>
